import './index.css';

const About = () => {
    return(
        <div>
            <h1 className="color1">This is About page.</h1>
        </div>
    );   
};
export default About;